import * as React from "react";
import { FilterLiveSearch, useTranslate } from 'react-admin';

export default (props) => {
    const t = useTranslate();

    return (
        <FilterLiveSearch source="userGradeId" label={t('components.list_filters.userGradeId', { _: "User grade ID" })} />
    )
};